export const SchoolReportWizardNav = () => (
  <div className="wizard-nav">
    <div className="wizard-steps">
      <button 
        type="button"
        className="wizard-step"
        data-wizard-type="step"
        style={{borderStyle: "none"}}
      >
        <div className="wizard-wrapper">
          <div className="wizard-number">1</div>
          <div className="wizard-label">
            <div className="wizard-title">Karne Tanımı</div>
          </div>
        </div>
      </button>
      <button 
        type="button"
        className="wizard-step"
        data-wizard-type="step"
        style={{borderStyle: "none"}}
      >
        <div className="wizard-wrapper">
          <div className="wizard-number">2</div>
          <div className="wizard-label">
            <div className="wizard-title">Karne Modülleri</div>
          </div>
        </div>
      </button>
      <button 
        type="button"
        className="wizard-step"
        data-wizard-type="step"
        style={{borderStyle: "none"}}
      >
        <div className="wizard-wrapper">
          <div className="wizard-number">3</div>
            <div className="wizard-label">
              <div className="wizard-title">Karne Öğrencileri</div>
            </div>
        </div>
      </button>
      <button 
        type="button"
        className="wizard-step"
        data-wizard-type="step"
        style={{borderStyle: "none"}}
      >
        <div className="wizard-wrapper">
          <div className="wizard-number">4</div>
          <div className="wizard-label">
            <div className="wizard-title">Karne Basımı</div>
          </div>
        </div>
      </button>
    </div>
  </div>   
);